<tui-root>
  @if (loggedIn$ | async) {
    <app-page-wrapper>
      <router-outlet />
    </app-page-wrapper>
  }
  <ng-container ngProjectAs="tuiOverContent" />
  <ng-container ngProjectAs="tuiOverDialogs" />
  <ng-container ngProjectAs="tuiOverAlerts" />
  <ng-container ngProjectAs="tuiOverPortals" />
  <ng-container ngProjectAs="tuiOverHints" />
</tui-root>